// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"433124bb","223":"16f44b3b","378":"15bbcd72","453":"5f441d32","538":"7502cfce","566":"6028ebf8","978":"af9c7da2"}[chunkId] + ".chunk.js";
};